import { useContext, useEffect, useState } from "react"
import { AppContext } from "../App"
import { PiBuildingOfficeBold, PiStudent } from "react-icons/pi";
import { callApi, formatDate, formatMoney, formatMoneyShorten } from "../Helpers";
import { FaChalkboardTeacher, FaChevronDown } from "react-icons/fa";
import { SiGoogleclassroom } from "react-icons/si";
import { IoIosPeople } from "react-icons/io";
import { getInlineLoader } from "../Helpers";
import OnePaymentRecord from '../ones/OnePaymentRecord';
import { MdCheck, MdSms, MdWhatsapp } from "react-icons/md";
import ClassroomRegistrationForm from "../ones/ClassroomRegistrationForm";
import StaffRegistrationForm from "../ones/StaffRegistrationForm";
import IncomeRecordForm from "../ones/IncomeRecordForm";
import ExpenseRecordForm from "../ones/ExpenseRecordForm";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);
	const [loading, setLoading] = useState(false);	

	const [searchFilter, setSearchFilter] = useState("");

	async function init() {
		//run initializations here
		setReady(false);
		await Promise.all([
			appContext.getAllPaymentRecords(),
			appContext.getTotalIncome(),
			appContext.getTotalExpenses(),
		]);
		setReady(true);
	}

	

	useEffect(() => {
		init();
	}, [])

	useEffect(() => {
		//..
	}, [appContext.allPaymentRecords])


	useEffect(() => {
		appContext.setShowOverlayLoader(loading);

		return () => {
			appContext.setShowOverlayLoader(false);
		}
	}, [ loading ])

	if (ready && appContext.allPaymentRecords) {
		return (
			<div
				className="container"
			>
				<div className="row">
					<div className="col-md-12">
						<h6 className="main-section-title">
							Accounting
						</h6>
					</div>

					<div className="col-12 col-md-12">
						<div
							className="card"
						>
							<div className="card-body">
								<div 
									className="d-flex justify-content-between"
									style={{
										cursor: "pointer",
									}}
									data-bs-toggle="collapse" 
									data-bs-target="#_classroomRegForm" 
									aria-expanded="false" 
									aria-controls="_classroomRegForm"
								>
									<h6
										className="sub-section-title align-self-center"
									>
										Record Income
									</h6>

									<FaChevronDown
										size={24}
										className="align-self-center text-secondary"
									/>
								</div>
								
								<div className="collapse" id="_classroomRegForm">
									<hr/>
									<IncomeRecordForm/>
								</div>
								
								
							</div>
						</div>
					</div>

					<div className="col-12 col-md-12">
						<div
							className="card"
						>
							<div className="card-body">
								<div 
									className="d-flex justify-content-between"
									style={{
										cursor: "pointer",
									}}
									data-bs-toggle="collapse" 
									data-bs-target="#_classroomRegForm2" 
									aria-expanded="false" 
									aria-controls="_classroomRegForm2"
								>
									<h6
										className="sub-section-title align-self-center"
									>
										Record Expenses
									</h6>

									<FaChevronDown
										size={24}
										className="align-self-center text-secondary"
									/>
								</div>
								
								<div className="collapse" id="_classroomRegForm2">
									<hr/>
									<ExpenseRecordForm/>
								</div>
								
								
							</div>
						</div>
					</div>

					<div className="col-12 col-md-6">
						<div
							className="card"
						>
							<div className="card-body">
								<div 
									className="d-flex justify-content-between"
									style={{
										cursor: "pointer",
									}}
									data-bs-toggle="collapse" 
									data-bs-target="#_classroomRegForm3" 
									aria-expanded="false" 
									aria-controls="_classroomRegForm3"
								>
									<h6
										className="sub-section-title align-self-center"
									>
										Income Report
									</h6>

									<FaChevronDown
										size={24}
										className="align-self-center text-secondary"
									/>
								</div>
								
								<div className="collapse" id="_classroomRegForm3">
									<hr/>
									<h6
										style={{
											fontSize: "14px"
										}}
										className="font-semi-bold text-muted text-end"
									>
										Total Income (TZS)
									</h6>
									<h6
										style={{
											fontSize: "24px"
										}}
										className="font-bold text-end text-success"
									>
										{formatMoney(appContext.totalIncome || 0)}
									</h6>

									<button
										className="btn btn-sm btn-block btn-outline-dark"
										onClick={() => {
											appContext.navTo({
												item: 'view',
												subItem: 'income-report'
											})
										}}
									>
										View Full Income Report
									</button>
								</div>
								
								
							</div>
						</div>
					</div>

					<div className="col-12 col-md-6">
						<div
							className="card"
						>
							<div className="card-body">
								<div 
									className="d-flex justify-content-between"
									style={{
										cursor: "pointer",
									}}
									data-bs-toggle="collapse" 
									data-bs-target="#_classroomRegForm4" 
									aria-expanded="false" 
									aria-controls="_classroomRegForm4"
								>
									<h6
										className="sub-section-title align-self-center"
									>
										Expenses Report
									</h6>

									<FaChevronDown
										size={24}
										className="align-self-center text-secondary"
									/>
								</div>
								
								<div className="collapse" id="_classroomRegForm4">
									<hr/>
									<h6
										style={{
											fontSize: "14px"
										}}
										className="font-semi-bold text-muted text-end"
									>
										Total Expenses (TZS)
									</h6>
									<h6
										style={{
											fontSize: "24px"
										}}
										className="font-bold text-end text-danger"
									>
										{formatMoney(appContext.totalExpenses || 0)}
									</h6>

									<button
										className="btn btn-sm btn-block btn-outline-dark"
										onClick={() => {
											appContext.navTo({
												item: 'view',
												subItem: 'expenses-report'
											})
										}}
									>
										View Full Expenses Report
									</button>
								</div>
								
								
							</div>
						</div>
					</div>

					<div className="col-md-12" id="_coinsOrdersList">
						<div
							className="card"
						>
							<div className="card-body">

								<div className="d-flex justify-content-between mb-4">

									<h6
										className="sub-section-title"
										
									>
										Student Payment Records
									</h6>

									<input
										className="form-control mNoMargin align-self-center"
										style={{
											width: "150px"
										}}
										onChange={(e) => setSearchFilter(e.target.value)}
										placeholder="Filter by name"
									/>

								</div>
								<hr/>

								{
									(appContext.allPaymentRecords && appContext.allPaymentRecords.length > 0) ?
										appContext.allPaymentRecords.map((item, i) => {
											if (searchFilter) {
												if (
													String(item.cycleTitle).toLowerCase().indexOf(String(searchFilter).toLowerCase()) > -1 
												) {
													return (
														<OnePaymentRecord data={item} key={i} />
													)
												} else {
													return "";
												}
											} else {
												return (
													<OnePaymentRecord data={item} key={i} />
												)
											}
										})
										:
										<h6
											className=""
											style={{
												fontSize: "14px",
											}}
										>
											No record was found
										</h6>
								}
							</div>

						</div>
					</div>

				</div>

			</div>
		)
	} else {
		return (
			<div
				className="container mSupportLoading"
			>
				{getInlineLoader()}
			</div>
		);
	}


}